import { useCallback, useState } from 'react';
import { useAttachmentFileBulkCreateMutation, useItemCreateMutation } from 'api';
import { Form, FormProps } from 'components';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { ItemAddFormFieldType } from 'pages/admin/items/addItem/index';

export const useAddItem = (props: { onModalStateChange: (value: boolean) => void }) => {
  const [attachments, setAttachments] = useState<{ type: string; file: any }[]>([]);
  const [fileList, setFileList] = useState<any[]>([]);
  const [attachmentType, setAttachmentType] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [form] = Form.useForm();
  const { onModalStateChange } = props;
  const [createItem] = useItemCreateMutation();
  const [createBulkFiles] = useAttachmentFileBulkCreateMutation();

  const { handleError, handleSuccess } = useNotificationMessages();

  const handleAttachmentChange = useCallback((attachments: { type: string; file: File }[]) => {
    setAttachments(attachments);
    // setDisableSaveBtn(false);
  }, []);

  const onCancel = useCallback(() => {
    form.resetFields();
    setAttachments([]);
    setFileList([]);
    setAttachmentType(undefined);
    // setDisableSaveBtn(true);
    onModalStateChange(false);
  }, [form, onModalStateChange]);
  const onFinish: FormProps<ItemAddFormFieldType>['onFinish'] = useCallback(
    async (values: ItemAddFormFieldType) => {
      const payload = values;
      payload.file = undefined;
      payload.attachmentTypes = attachments.map((att) => att.type);
      try {
        setIsLoading(true);
        const { data, error } = await createItem(payload);
        if (!data?.success) return handleError(error);

        if (attachments.length && Array.isArray(data.data)) {
          const form = new FormData();
          form.append('attachmentIds', data.data.join(','));
          attachments.forEach((att) => form.append('files', att.file));
          form.append('serviceName', 'ITEM');
          await createBulkFiles({ data: form, entityName: 'ITEM' });
        }
        handleSuccess(`The item was successfully added`);
        onCancel();
      } catch (err) {
        handleError(err);
      } finally {
        setIsLoading(false);
      }
    },
    [createItem, onCancel, handleSuccess, handleError, attachments, createBulkFiles]
  );

  return {
    form,
    onCancel,
    onFinish,
    isLoading,
    attachments,
    setAttachmentType,
    fileList,
    handleAttachmentChange,
    attachmentType,
    setFileList,
  };
};
